<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px','max-height':'800px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >
    
            <FormItem :label="$t('BasicProduct.funcBox.titleNameLog.UpdateContents')" prop="UpdateContents" style="width: 600px">
                <Input type="text" v-model.trim="formData.UpdateContents" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('BasicProduct.funcBox.titleNameLog.Remark')" prop="Remark" style="width: 600px">
                <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.Remark" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>
            
            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>


    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
        },
        name: "Model3",
        components: {
        },
        data() {
            return {   
                
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    UpdateContents: '',
                    Remark:'',
                }, 
               
            }
        },
        watch:{
            showSetModel(val){
                if(val){
                  
                }
            },
        },
        computed:{
            ...mapState(['local','selectId']),

             ruleCustom(){
                 return {//验证
                    UpdateContents: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    
                }
             } 

        },
        created(){
           
        },
        mounted(){
          
        },
        methods: {
         
            openOrClose(value) {
                if(value === true) {
                   
                    this.title = "更新记录"
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // this.disabled = true;
                        // this.formData.orderName = this.formData.orderId
                        // this.axios.post(this.config.urlArray.orderAdd, {...this.formData,dealerId:this.selectId}).then((result) => {
                            
                        //     common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                        //         this.resetForm();//重置表单
                        //         this.fn()
                        //     },()=>{this.disabled = false})
                            
                        // }).catch((err) => {
                        //     // common.msg('error','提交失败',()=>{this.disabled = false;})
                        //     this.disabled = false
                        // });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showSetModel',false);
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.formData.Remark = ''
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.IndentyNameTextG{
    padding: 0px 7px;
    font-size: 14px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    color: #C5C8CE;
    cursor: pointer;
    overflow: hidden;
}
.IndentyNameText{
    color: #515a6e;
}
</style>

